// extracted by mini-css-extract-plugin
export default {"container":"CNYvkvUlil9VULnrN4p5zw==","list":"ThuSFyxz-Mfht7YSon9JaQ==","title":"LF+elcrpYHjBHYXRHwt64Q==","list-item":"WoRam6kwmDBcrpHpmc5yCA=="};